import React, { useEffect, useState } from "react";
import { BaseWidgetProps } from "../ClientWidget";
import "./ClockWidget.scss";
import { __ } from "../../../appcontext";

export default function K2ClockWidget(props: BaseWidgetProps) {
  const [dateTime, setDateTime] = useState(new Date());
  const dayOfWeek = [
    __("sundayShort"),
    __("mondayShort"),
    __("tuesdayShort"),
    __("wednesdayShort"),
    __("thursdayShort"),
    __("fridayShort"),
    __("saturdayShort"),
  ];
  let styleType = "0";

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  function getDate() {
    return dayOfWeek[dateTime.getDay()] + " " + dateTime.getDate() + "." + (dateTime.getMonth() + 1) + "." + dateTime.getFullYear();
  }
  function getHours() {
    return dateTime.getHours() >= 10 ? dateTime.getHours() : "0" + dateTime.getHours();
  }
  function getMinutes() {
    return dateTime.getMinutes() >= 10 ? dateTime.getMinutes() : "0" + dateTime.getMinutes();
  }
  function getSeconds() {
    return dateTime.getSeconds() >= 10 ? dateTime.getSeconds() : "0" + dateTime.getSeconds();
  }
  if (props.AdditionalField === "1") {
    styleType = "1";
  }

  return (
    <div className={`cw_clock style_${styleType}`}>
      <div className="cw_clock_time">
        <div className="cw_clock_hours" title={__("clockHours")}>
          <span>{getHours()}</span>
        </div>
        <span className="cw_separator">:</span>
        <div className="cw_clock_minutes" title={__("clockMinutes")}>
          <span>{getMinutes()}</span>
        </div>
        <span className="cw_separator">:</span>
        <div className="cw_clock_seconds" title={__("clockSeconds")}>
          <span>{getSeconds()}</span>
        </div>
      </div>
      <div className="cw_clock_date" title={__("clockDate")}>
        <span>{getDate()}</span>
      </div>
    </div>
  );
}
